import { JSX } from "react";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  Chip,
  ChipOwnProps,
  SxProps,
  Tooltip,
  TooltipProps,
} from "@mui/material";

const SuccessChip = ({
  sx,
  info,
  label,
  size = "medium",
  placement = "bottom",
}: {
  sx?: SxProps;
  info?: string;
  label?: string | JSX.Element;
  size?: ChipOwnProps["size"];
  placement?: TooltipProps["placement"];
}) => (
  <Tooltip title={info} placement={placement} sx={sx}>
    {label ? (
      <Chip
        color="success"
        size={size}
        label={label}
        icon={<CheckCircleIcon />}
      />
    ) : (
      <CheckCircleIcon color="success" />
    )}
  </Tooltip>
);

export default SuccessChip;
